import React, { useEffect } from "react";
import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";
import { useAlert } from "../../../context/AlertContext";
import { Banner, BannerText, BannerLogo } from "../../../styles/Banner";
import { Box, Typography, Container, Grid, TextField, Button, CircularProgress } from "@mui/material";
import useSendJobsFeedback from "../../../hooks/useSendJobsFeedback";
const Jobs = () => {



    const { sendJobsFeedback, response, loading, error } = useSendJobsFeedback();
    const { showAlert } = useAlert();

    const [form, setForm] = React.useState({
        name: '',   
        email: '',  
        city: '',
        telephone: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.city || !form.email|| !form.telephone ) {
            showAlert("Preencha todos os campos", "warning");
            return;
        }
        await sendJobsFeedback(form);
    };

    useEffect(() => {
        if (response) {
            setForm({
                name: '',   
                email: '',  
                city: '',
                telephone: ''
            })
            showAlert(response, 'success');
        }
    }, [response]);

    useEffect(() => {
    if (error) {
        showAlert(error, "error");
    }
    }, [error]);


    return(
        <>
            <NavBar />
            <Banner>
                <BannerText>
                    <p>
                        <a href="https://www.meucupom.com/" target="_blank" rel="noreferrer">Home</a> &gt; Institucional &gt; Trabalhe Conosco
                    </p>
                    <Box>
                        <Typography variant='h2' sx={{
                        fontSize: { xs: '1.2rem', sm: '2rem', md: '2rem' },
                        fontWeight: 'bold',
                        textAlign: 'center'
                        }}>Trabalhe Conosco</Typography>
                    </Box>

                </BannerText>
                <BannerLogo>
                    <img 
                        src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png" 
                        alt="MeuCupom Logo" 
                    />
                </BannerLogo>
            </Banner>
            <Container maxWidth="md" sx={{ py: 6 }}>
                <Box sx={{ mb: 5 }}>
                    <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, textAlign: "center", fontSize: { xs: '1.5rem', sm: '2rem', md: '2rem' } }}>
                        Faça parte da nossa equipe!
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
                        A pw brands, holding de negócios digitais, junto ao MeuCupom.com estão em expansão e buscando cada vez mais por funcionários envolvidos, comprometidos e com muita vontade de aprender e trabalhar de forma leve, descontraída e dedicada.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
                        Buscamos por profissionais que contribuam com qualidade de serviço, profissionalismo e alto astral. Se você se enquadra nesse perfil e quer trabalhar com a gente, entre em contato e envie seu currículo! A meta é o infinito, e é claro, além!
                    </Typography>
                    <Typography 
                    variant="h6" 
                    sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}
                >
                    Envie seu contato para nosso RH
                </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold", textAlign: "center" }}>
                        📧 rh@meucupom.com
                    </Typography>
                </Box>
                <Box onSubmit={handleSubmit} component="form" noValidate autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField 
                                fullWidth 
                                name='name'
                                value={form.name}
                                onChange={handleChange}
                                label="Nome completo" 
                                variant="outlined" 
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField 
                                fullWidth 
                                name='email'
                                label="E-mail" 
                                onChange={handleChange}
                                type="email" 
                                value={form.email}
                                variant="outlined" 
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField 
                                fullWidth 
                                name='telephone'
                                onChange={handleChange}
                                label="Telefone / WhatsApp" 
                                type="tel" 
                                value={form.telephone}
                                variant="outlined" 
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField 
                                fullWidth 
                                name='city'
                                onChange={handleChange}
                                value={form.city}
                                label="Cidade / Estado" 
                                variant="outlined" 
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                            <Button 
                                variant="contained" 
                                type="submit"
                                color="primary"
                                sx={{ mt: 2, px: 12, py: 2, borderRadius: "8px" }}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : 'Enviar'}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <Footer/>
        </>
    )
}
export default Jobs;